module.exports = __webpack_public_path__ + "static/media/22ESCWA6.de26a0e6.jpg";